howspace.progress = (() => {
    'use strict';

    const myProgress = $('#my-progress');
    const myProgressBtn = $('.my-progress-btn');

    const showMyProgress = () => {
        if (myProgress.hasClass('expanded')) {
            return;
        }

        howspace.workspace.sidebar.open(myProgress);

        myProgress.one('transitionend', () => {
            scrollToNextActivity();
        });
    };

    const hideMyProgress = () => {
        if (!myProgress.hasClass('expanded')) {
            return;
        }

        howspace.workspace.sidebar.close();

        real.localStorage.set('#my-progress', 'hidden');
    };

    const updateMyProgress = () => {
        if (myProgress.length === 0) {
            return;
        }

        real.ajax.json('/menu/my-progress', {
            type: 'GET',
            success: function (response) {
                if (response.sidebar) {
                    myProgress.html(response.sidebar);
                    howspace.components.init(myProgress);

                    myProgressBtn.removeClass('d-none');
                    const progressCircle = myProgressBtn.find('.howspace-progress-circle');
                    howspace.components.progress.update(progressCircle, response.results.progress.percentage);

                    scrollToNextActivity();
                } else {
                    myProgressBtn.addClass('d-none');

                    if (myProgress.hasClass('expanded')) {
                        howspace.workspace.sidebar.close();
                    }
                }
            }
        });
    };

    const scrollToNextActivity = () => {
        const nextActivity = myProgress.find('.next');
        const showCertificateBtn = myProgress.find('.show-certificate-btn');

        if (nextActivity.length > 0) {
            howspace.scroller.scrollToElement(nextActivity);
            nextActivity.find('.btn-primary').trigger('focus');
        } else if (showCertificateBtn.length > 0) {
            howspace.scroller.scrollToElement(showCertificateBtn);
        } else {
            howspace.scroller.scrollToElement(myProgress.find('.total'));
        }
    };

    const getDataPayload = (modal) => {
        const dataPayload = real.form.getDataPayload(modal);

        if (!dataPayload.progress_settings) {
            dataPayload.progress_settings = {};
        }

        if (!dataPayload.progress_settings.activities) {
            dataPayload.progress_settings.activities = [];
        }

        if (dataPayload.progress_settings.minimum_score === undefined) {
            dataPayload.progress_settings.minimum_score = 0;
        }

        return dataPayload;
    };

    /**
     * Check if the minimum score is valid based on selected activities, their max scores and multipliers
     * @param {*} modal
     * @returns
     */
    const isValidMinimumScore = (modal) => {
        const payload = getDataPayload(modal);
        if (payload.progress_settings.minimum_score <= 0) {
            return true;
        }

        if (payload.progress_settings.activities.length === 0) {
            return true;
        }

        let totalScore = 0;
        for (const activity of payload.progress_settings.activities) {
            const activityId = activity.id;
            const activityType = activity.type;
            const scoreMultiplier = activity.value || 1;

            const maxScoreElement = modal.find(`.item[data-id="${activityType}-${activityId}"] .max-score`);
            const maxScore = parseFloat(maxScoreElement.text()) || 1;

            totalScore += maxScore * scoreMultiplier;
        }

        if (totalScore < payload.progress_settings.minimum_score) {
            return false;
        }
        return true;
    };

    /**
     * Validate minimum score and toggle save button state
     * @param {*} modal
     */
    const validateMinimumScoreAndToggleSave = (modal) => {
        const input = modal.find('input.minimum-score-input');
        const isInvalid = !isValidMinimumScore(modal);

        if (isInvalid) {
            howspace.form.markInvalidField(input);
        } else {
            howspace.form.clearInvalidField(input);
        }

        modal.find('.save-button').prop('disabled', isInvalid);
    };

    const initSettingsModal = (modal) => {
        modal = $(modal);

        modal.find('.btn[data-close-modal=true]').on('click', () => {
            const dataPayload = getDataPayload(modal);

            if (!howspace.jsonCompare(dataPayload.progress_settings, modal.data('settings'))) {
                const content = howspace.translate('workspacesettings_progress_settings_unsaved_changes');

                if (confirm(content)) {
                    howspace.components.modal.close(modal);
                }
            } else {
                howspace.components.modal.close(modal);
            }

            return false;
        });

        modal.find('input.minimum-score-input').on('input', (e) => {
            const input = $(e.currentTarget);
            howspace.form.clearInvalidField(input)
        });

        modal.find('input.minimum-score-input').on('change', () => {
            validateMinimumScoreAndToggleSave(modal);
        });
        modal.find('input.value').on('change', () => {
            validateMinimumScoreAndToggleSave(modal);
        });
        modal.on(howspace.components.itemPicker.ITEM_ADDED, () => {
            validateMinimumScoreAndToggleSave(modal);
        });
        modal.on(howspace.components.itemPicker.ITEM_REMOVED, () => {
            validateMinimumScoreAndToggleSave(modal);
        });

        modal.find('.approval-mode-radio').on('change', (e) => {
            // Add a slight delay to ensure that the collapse/expand animation completes before validating
            setTimeout(() => {
                validateMinimumScoreAndToggleSave(modal);
            }, 500);
        });

        modal.find('.save-button').on('click', () => {
            const dataPayload = getDataPayload(modal);
            if (!isValidMinimumScore(modal)) {
                howspace.form.markInvalidField(modal.find('.minimum-score-input'));
                return;
            }

            real.ajax.json(`${real.baseUri}/api/workspace/${real.dom.$body.data('workspace-id')}`, {
                type: 'POST',
                data: JSON.stringify(dataPayload),
                complete: () => {
                    howspace.components.modal.close(modal);
                }
            });
        });
    };

    real.dom.$body.on('click', '.my-progress-btn', () => {
        if (myProgress.hasClass('expanded')) {
            hideMyProgress();
        } else {
            showMyProgress();
        }
    });

    real.dom.$body.on('click', '#my-progress a', () => {
        hideMyProgress();
    });

    real.dom.$body.on('click', '#my-progress .close-sidebar-btn', () => {
        hideMyProgress();
        return false;
    });

    real.events.on('workspace:user:progress:updated', updateMyProgress);
    real.events.on('workspace:progress:updated', updateMyProgress);

    return {
        showMyProgress: showMyProgress,
        initSettingsModal: initSettingsModal,
        updateMyProgress: updateMyProgress,
        scrollToNextActivity: scrollToNextActivity
    };
})();
